import React from "react";
import "./styles.scss";
import Card from "../Card";

export default function OldSiteWarning() {
    return <Card className="old-site-warning">
        <h2>Uwaga!</h2>
        <p>Przeglądasz stronę <strong>wcześniejszej edycji</strong> Ogólnopolskiego Dnia Widoczności Osób Transpłciowych. <strong>Strona aktualnej edycji znajduje się na <a href="https://dzientrans.pl/">dzientrans.pl</a>.</strong></p>
    </Card>
}